module.exports = __webpack_public_path__ + "static/intro-ffa5bfdabe933d1ef7484e31e1f6fd76.mp4";